 ///{% comment %}  Starting      code created by faisal codex {% endcomment %}

class ShopifyWishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist_items';
    this.items = this.getStoredItems();
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.bindEvents();
    this.updateAllWishlistButtons();
    this.createNotificationContainer();
    console.log('Wishlist initialized with', this.items.length, 'items');
  }

  bindEvents() {
    // Handle wishlist button clicks
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.wishlist-btn');
      if (!wishlistBtn) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      // Visual feedback
      wishlistBtn.style.transform = 'scale(0.95)';
      setTimeout(() => {
        wishlistBtn.style.transform = '';
      }, 150);
      
      this.toggleWishlistItem(wishlistBtn);
    });

    // Listen for page changes (AJAX themes)
    window.addEventListener('popstate', () => {
      setTimeout(() => this.updateAllWishlistButtons(), 100);
    });
  }

  getStoredItems() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error loading wishlist:', error);
      return [];
    }
  }

  saveItems() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
      
      // Dispatch event for other scripts
      window.dispatchEvent(new CustomEvent('wishlistUpdated', {
        detail: { items: this.items, count: this.items.length }
      }));
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }
  }

  toggleWishlistItem(button) {
    const productData = this.extractProductData(button);
    
    if (!productData.id) {
      console.error('Product ID not found');
      return;
    }

    const existingIndex = this.items.findIndex(item => item.id === productData.id);

    if (existingIndex !== -1) {
      // Remove from wishlist
      this.items.splice(existingIndex, 1);
      this.updateButtonState(button, false);
      this.showNotification(`${productData.title} removed from wishlist`, 'removed');
    } else {
      // Add to wishlist
      this.items.push({
        ...productData,
        dateAdded: new Date().toISOString()
      });
      this.updateButtonState(button, true);
      this.showNotification(`${productData.title} added to wishlist`, 'added');
    }

    this.saveItems();
    this.updateWishlistCount();
  }

  extractProductData(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      url: button.dataset.productUrl,
      variantId: button.dataset.variantId
    };
  }

  updateButtonState(button, isInWishlist) {
    button.classList.toggle('active', isInWishlist);
    button.setAttribute('aria-label', 
      isInWishlist ? `Remove ${button.dataset.productTitle} from wishlist` : `Add ${button.dataset.productTitle} to wishlist`
    );
    
    // Update icon fill
    const icon = button.querySelector('.wishlist-icon');
    if (icon) {
      if (isInWishlist) {
        icon.setAttribute('fill', 'currentColor');
      } else {
        icon.setAttribute('fill', 'none');
      }
    }
  }

  updateAllWishlistButtons() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      const isInWishlist = this.isInWishlist(productId);
      this.updateButtonState(button, isInWishlist);
    });
    this.updateWishlistCount();
  }

  isInWishlist(productId) {
    return this.items.some(item => item.id === productId);
  }

  updateWishlistCount() {
    const countElements = document.querySelectorAll('[data-wishlist-count]');
    countElements.forEach(element => {
      element.textContent = this.items.length;
      element.style.display = this.items.length > 0 ? 'inline' : 'none';
    });
  }

  // Public methods
  getItems() {
    return [...this.items];
  }

  getCount() {
    return this.items.length;
  }

  removeItem(productId) {
    const initialLength = this.items.length;
    this.items = this.items.filter(item => item.id !== productId);
    
    if (this.items.length < initialLength) {
      this.saveItems();
      this.updateAllWishlistButtons();
      return true;
    }
    return false;
  }

  clearAll() {
    this.items = [];
    this.saveItems();
    this.updateAllWishlistButtons();
    this.showNotification('Wishlist cleared', 'removed');
  }

  createNotificationContainer() {
    if (!document.getElementById('wishlist-notifications')) {
      const container = document.createElement('div');
      container.id = 'wishlist-notifications';
      container.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        pointer-events: none;
        display:none;
      `;
      document.body.appendChild(container);
    }
  }

  showNotification(message, type = 'added') {
    const container = document.getElementById('wishlist-notifications');
    if (!container) return;

    const notification = document.createElement('div');
    notification.style.cssText = `
      background: ${type === 'added' ? '#10b981' : '#dc2626'};
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 14px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateX(100%);
      transition: transform 0.3s ease;
      pointer-events: auto;
      max-width: 300px;
      word-wrap: break-word;
    `;
    notification.textContent = message;

    container.appendChild(notification);

    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Remove after delay
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
}

// Initialize wishlist
function initializeWishlist() {
  window.shopifyWishlist = new ShopifyWishlist();
  
  // Debug helpers
  window.wishlistDebug = {
    getItems: () => window.shopifyWishlist.getItems(),
    getCount: () => window.shopifyWishlist.getCount(),
    clear: () => window.shopifyWishlist.clearAll(),
    test: () => console.log('Wishlist items:', window.shopifyWishlist.getItems())
  };
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWishlist);
} else {
  initializeWishlist();
}

// Handle theme section reloads
document.addEventListener('shopify:section:load', () => {
  if (window.shopifyWishlist) {
    setTimeout(() => {
      window.shopifyWishlist.updateAllWishlistButtons();
    }, 100);
  }
});





document.addEventListener('DOMContentLoaded', function() {
  const wishlist = window.shopifyWishlist;
  if (!wishlist) {
    console.error('Wishlist not initialized');
    return;
  }

  const emptyEl = document.querySelector('[data-wishlist-empty]');
  const productsEl = document.querySelector('[data-wishlist-products]');
  const gridEl = document.querySelector('[data-products-grid]');
  const countEl = document.querySelector('[data-wishlist-count]');
  const clearBtn = document.querySelector('[data-clear-wishlist]');

  // =================== WISHLIST FUNCTIONS ===================

  function renderWishlist() {
    const items = wishlist.getItems();
    console.log('Raw wishlist items:', items);
    
    // More thorough deduplication - check by multiple criteria
    const uniqueItems = [];
    const seenIds = new Set();
    const seenHandles = new Set();
    
    items.forEach(item => {
      const itemId = item.id || item.productId;
      const itemHandle = item.handle;
      
      // Skip if we've already seen this ID or handle
      if ((itemId && seenIds.has(itemId)) || (itemHandle && seenHandles.has(itemHandle))) {
        console.log('Skipping duplicate item:', { id: itemId, handle: itemHandle });
        return;
      }
      
      // Add to tracking sets
      if (itemId) seenIds.add(itemId);
      if (itemHandle) seenHandles.add(itemHandle);
      
      uniqueItems.push(item);
    });
    
    console.log('Unique items after thorough deduplication:', uniqueItems);
    
    if (countEl) countEl.textContent = uniqueItems.length;

    if (uniqueItems.length === 0) {
      showEmptyState();
    } else {
      showWishlistItems(uniqueItems);
    }
  }

  function showEmptyState() {
    if (emptyEl) emptyEl.style.display = 'block';
    if (productsEl) productsEl.style.display = 'none';
  }

  function showWishlistItems(items) {
    if (emptyEl) emptyEl.style.display = 'none';
    if (productsEl) productsEl.style.display = 'block';
    renderProducts(items);
  }

  async function renderProducts(items) {
    if (!gridEl) {
      console.error('Grid element not found');
      return;
    }
    
    // Clear the grid completely before rendering
    gridEl.innerHTML = '';
    
    // Track processed items more thoroughly
    const processedIds = new Set();
    const processedHandles = new Set();

    for (const item of items) {
      // Skip if already processed by ID or handle
      const itemId = item.id || item.productId;
      const itemHandle = item.handle;
      
      if ((itemId && processedIds.has(itemId)) || (itemHandle && processedHandles.has(itemHandle))) {
        console.warn('Duplicate item detected during rendering, skipping:', { id: itemId, handle: itemHandle });
        continue;
      }
      
      // Add to processed tracking
      if (itemId) processedIds.add(itemId);
      if (itemHandle) processedHandles.add(itemHandle);

      try {
        if (!item.handle) throw new Error('Missing product handle');
        const response = await fetch(`/products/${item.handle}.js`);
        if (!response.ok) throw new Error(`Product fetch failed for handle: ${item.handle}`);
        const product = await response.json();
        console.log('Fetched product:', { handle: item.handle, price: product.variants?.[0]?.price, product });
        
        const productCard = document.createElement('div');
        productCard.innerHTML = renderProductCard(product);
        if (productCard.firstElementChild) {
          gridEl.appendChild(productCard.firstElementChild);
        } else {
          console.error(`Invalid product card for handle: ${item.handle}`);
        }
      } catch (error) {
        console.error('Error fetching product:', item.handle, error);
        const fallbackCard = document.createElement('div');
        fallbackCard.innerHTML = renderFallbackCard(item);
        if (fallbackCard.firstElementChild) {
          gridEl.appendChild(fallbackCard.firstElementChild);
        }
      }
    }
  }

  function renderProductCard(product) {
    // Ensure product has necessary data
    const title = product.title || 'Untitled Product';
    const price = product.variants && product.variants[0]?.price ? formatMoney(product.variants[0].price) : 'N/A';
    const image = product.featured_image || 'https://via.placeholder.com/150';
    const url = product.url || `/products/${product.handle || '#'}`;
    const handle = product.handle || '#';
    const variantId = product.variants?.[0]?.id || '';

    return `
      <div class="wishlist-item" data-product-id="${product.id || 'unknown'}" data-product-handle="${handle}">
        <div class="wishlist-item-image">
          <a href="${url}">
            <img src="${image}" alt="${title}" loading="lazy">
          </a>
          <button class="remove-btn" data-remove="${product.id || 'unknown'}" title="Remove from wishlist">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <button class="add-to-cart-overlay-btn" 
            data-product-id="${product.id || ''}"
            data-variant-id="${variantId}"
            data-product-handle="${handle}"
            data-product-title="${title}"
            data-product-image="${image}"
            data-product-price="${product.variants?.[0]?.price || ''}"
            data-product-url="${url}"
            type="button"
            title="Add ${title} to cart"
            aria-label="Add ${title} to cart"
          >
            <svg class="basket-icon" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path stroke-miterlimit="10" d="M7.1802 7.58C7.1802 4.36 9.2402 1.75 11.7902 1.75C14.3402 1.75 16.4002 4.36 16.4002 7.58M11.7902 7.58C2.0402 7.58 0.690197 6.97 2.3502 16.18C3.3002 21.48 3.9802 22.22 11.7902 22.22C19.6002 22.22 20.2802 21.47 21.2302 16.18C22.8902 6.97 21.5502 7.58 11.7902 7.58Z"></path>
            </svg>
            <span class="overlay-loader">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
        <div class="wishlist-item-info">
          <h3 class="product-card__title reversed-link text-base-xl font-medium leading-tight">
            <a href="${url}">${title}</a>
          </h3>
          <div class="wishlist-item-price">
            ${price}
          </div>
        </div>
      </div>
    `;
  }

  function renderFallbackCard(item) {
    // Fallback card with minimal data
    const title = item.title || item.handle?.replace(/-/g, ' ') || 'Unknown Product';
    const price = item.price ? formatMoney(item.price) : 'N/A';
    const image = item.image || 'https://via.placeholder.com/150';
    const url = item.url || `/products/${item.handle || '#'}`;
    const variantId = item.variant_id || '';

    return `
      <div class="wishlist-item" data-product-id="${item.id || 'unknown'}" data-product-handle="${item.handle || 'unknown'}">
        <div class="wishlist-item-image">
          <a href="${url}">
            <img src="${image}" alt="${title}" loading="lazy">
          </a>
          <button class="remove-btn" data-remove="${item.id || 'unknown'}" title="Remove from wishlist">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <button class="add-to-cart-overlay-btn" 
            data-product-id="${item.id || ''}"
            data-variant-id="${variantId}"
            data-product-handle="${item.handle || ''}"
            data-product-title="${title}"
            data-product-image="${image}"
            data-product-price="${item.price || ''}"
            data-product-url="${url}"
            type="button"
            title="Add ${title} to cart"
            aria-label="Add ${title} to cart"
          >
            <svg class="basket-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M7 4V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2"/>
              <path d="M5 7h14l-1 10H6L5 7Z"/>
              <path d="M5 7l-1-3H2"/>
              <circle cx="9" cy="20" r="1"/>
              <circle cx="15" cy="20" r="1"/>
            </svg>
            <span class="overlay-loader">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
        <div class="wishlist-item-info">
          <h3 class="product-card__title reversed-link text-base-xl font-medium leading-tight">
            <a href="${url}">${title}</a>
          </h3>
          <div class="wishlist-item-price">
            ${price}
          </div>
        </div>
      </div>
    `;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      const formatted = Shopify.formatMoney(cents);
      // Remove trailing currency code (e.g., "USD") if present
      return formatted.replace(/\s*\w+$/, '').trim();
    } else {
      // Fallback if Shopify.formatMoney is unavailable
      const amount = (cents / 100).toFixed(2);
      return `$${amount}`;
    }
  }

  // =================== THEME-INTEGRATED ADD TO CART FUNCTIONS ===================

  // Add to Cart Function - Now uses theme's system
  async function addToCart(variantId, quantity = 1, properties = {}) {
    try {
      console.log('Adding to cart using theme system:', { variantId, quantity });
      
      // Show loading state
      const button = document.querySelector(`[data-variant-id="${variantId}"].add-to-cart-overlay-btn`);
      if (button) {
        button.classList.add('loading');
        button.disabled = true;
      }

      // Get all cart drawer section IDs that need to be updated
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));

      console.log('Sections to bundle:', sectionsToBundle);

      // Prepare cart data using theme's structure
      const cartData = {
        items: [{
          id: variantId,
          quantity: quantity,
          properties: properties
        }],
        sections: sectionsToBundle
      };

      // Use theme's fetchConfig and cart add URL
      const response = await fetch(theme.routes.cart_add_url, {
        ...theme.utils.fetchConfig(),
        body: JSON.stringify(cartData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.description || 'Failed to add item to cart');
      }

      const result = await response.json();
      console.log('Cart add result:', result);

      // Show success message
      showAddToCartSuccess();

      // Trigger theme's cart update system
      if (result.sections) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'wishlist-add-to-cart',
          cart: result,
          sections: result.sections
        });
      }

      // Trigger cart refresh event to open drawer
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { 
          open: true,
          cart: result
        }
      }));

      // Update cart count if available
      if (result.item_count !== undefined) {
        updateCartCount(result.item_count);
      }

      return result;

    } catch (error) {
      console.error('Add to cart error:', error);
      showAddToCartError(error.message || 'Failed to add item to cart');
      throw error;
    } finally {
      // Remove loading state
      const button = document.querySelector(`[data-variant-id="${variantId}"].add-to-cart-overlay-btn`);
      if (button) {
        button.classList.remove('loading');
        button.disabled = false;
      }
    }
  }

  // Update cart count using theme's approach
  function updateCartCount(count) {
    // Update cart count elements
    const cartCountElements = document.querySelectorAll('cart-count, .cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = count;
      if (element.hasAttribute('aria-label')) {
        const label = element.getAttribute('aria-label').replace(/\d+/, count);
        element.setAttribute('aria-label', label);
      }
      
      if (count === 0) {
        element.setAttribute('hidden', '');
      } else {
        element.removeAttribute('hidden');
      }
    });
  }

  // Show Success Message
  function showAddToCartSuccess() {
    const toast = document.createElement('div');
    toast.className = 'cart-toast cart-toast--success';
    toast.innerHTML = `
      <div class="cart-toast__content">
        <svg class="icon icon-check" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
        </svg>
        <span>Added to cart!</span>
      </div>
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.remove();
    }, 3000);
  }

  // Show Error Message
  function showAddToCartError(message) {
    const toast = document.createElement('div');
    toast.className = 'cart-toast cart-toast--error';
    toast.innerHTML = `
      <div class="cart-toast__content">
        <svg class="icon icon-x" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"/>
        </svg>
        <span>Error: ${message}</span>
      </div>
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.remove();
    }, 5000);
  }

  // =================== EVENT LISTENERS ===================

  // Listen to theme's cart update events
  document.addEventListener('cart:updated', (event) => {
    console.log('Cart updated event received:', event.detail);
    if (event.detail.cart && event.detail.cart.item_count !== undefined) {
      updateCartCount(event.detail.cart.item_count);
    }
  });

  // Combined Event Listener for both Wishlist and Add to Cart
  document.addEventListener('click', async (e) => {
    // Handle wishlist remove
    if (e.target.closest('[data-remove]')) {
      const removeBtn = e.target.closest('[data-remove]');
      const productId = removeBtn.dataset.remove;
      const productCard = removeBtn.closest('.wishlist-item');
      
      if (confirm('Remove this item from your wishlist?')) {
        console.log('Removing product ID:', productId);
        
        // Remove from wishlist data
        wishlist.removeItem(productId);
        
        // Immediately remove the DOM element
        if (productCard) {
          productCard.remove();
        }
        
        // Update count immediately
        const items = wishlist.getItems();
        if (countEl) countEl.textContent = items.length;
        
        // Check if we need to show empty state
        if (items.length === 0) {
          showEmptyState();
        }
        
        console.log('Product removed, remaining items:', items.length);
      }
    }

    // Handle add to cart
    const addToCartBtn = e.target.closest('.add-to-cart-btn') || e.target.closest('.add-to-cart-overlay-btn');
    if (addToCartBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = addToCartBtn.dataset.variantId;
      const quantity = parseInt(addToCartBtn.dataset.quantity) || 1;
      
      if (!variantId) {
        showAddToCartError('Product variant not found');
        return;
      }
      
      try {
        await addToCart(variantId, quantity);
      } catch (error) {
        // Error already handled in addToCart function
      }
    }
  });

  // Clear all wishlist items
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (confirm('Are you sure you want to clear your entire wishlist?')) {
        wishlist.clearAll();
        renderWishlist();
      }
    });
  }

  // Listen for wishlist updates
  window.addEventListener('wishlistUpdated', renderWishlist);

  // Export functions for global use
  window.addToCart = addToCart;
  window.quickAddToCart = function(productData) {
    const variantId = productData.variant_id || productData.variants?.[0]?.id;
    if (variantId) {
      addToCart(variantId, 1);
    }
  };

  // Initial render
  renderWishlist();
});

// Inject CSS for Add to Cart and Toast styles
const addToCartStyles = `
  <style>
    /* Wishlist Item Image Container */
    .wishlist-item-image {
      position: relative;
      overflow: hidden;
      border-radius: 8px;
    }
    
    /* Add to Cart Overlay Button */
    .add-to-cart-overlay-btn {
      position: absolute;
      bottom: 8px;
      right: 8px;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.95);
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      opacity: 0;
      transform: translateY(10px);
      z-index: 10;
    }
    
    /* Show overlay button on hover */
    .wishlist-item-image:hover .add-to-cart-overlay-btn {
      opacity: 1;
      transform: translateY(0);
    }
    
    /* Basket Icon */
    .add-to-cart-overlay-btn .basket-icon {
      width: 20px;
      height: 20px;
      stroke: #333;
      stroke-width: 2;
      transition: stroke 0.2s ease;
    }
    
    /* Hover Effects */
    .add-to-cart-overlay-btn:hover {
      color: rgb(var(--color-button-text));
      background: var(--color-button-gradient);
      transform: scale(1.05);
    }
    
    .add-to-cart-overlay-btn:hover .basket-icon {
      stroke: white;
    }
    
    /* Loading State for Overlay Button */
    .add-to-cart-overlay-btn.loading {
      background: #333;
    }
    
    .add-to-cart-overlay-btn.loading .basket-icon {
      opacity: 0;
    }
    
    .add-to-cart-overlay-btn.loading .overlay-loader {
      display: block;
    }
    
    .add-to-cart-overlay-btn .overlay-loader {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    
    .overlay-loader span {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: white;
      margin: 0 1px;
      animation: overlayLoading 1.4s infinite ease-in-out both;
    }
    
    .overlay-loader span:nth-child(1) { animation-delay: -0.32s; }
    .overlay-loader span:nth-child(2) { animation-delay: -0.16s; }
    .overlay-loader span:nth-child(3) { animation-delay: 0s; }
    
    @keyframes overlayLoading {
      0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.5;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }
    
    /* Remove Button Positioning */
    .wishlist-item-image .remove-btn {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 11;
    }
    
    /* Toast Notifications */
    .cart-toast {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      background: white;
      border-radius: 8px;
      padding: 16px 20px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-left: 4px solid;
      animation: slideIn 0.3s ease-out;
      max-width: 300px;
    }
    
    .cart-toast--success {
      border-left-color: #10b981;
      color: #065f46;
    }
    
    .cart-toast--error {
      border-left-color: #ef4444;
      color: #991b1b;
    }
    
    .cart-toast__content {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 500;
    }
    
    .cart-toast .icon {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
    
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    /* Mobile Responsive */
    @media (max-width: 768px) {
      .add-to-cart-overlay-btn {
        opacity: 1;
        transform: translateY(0);
        width: 36px;
        height: 36px;
      }
      
      .add-to-cart-overlay-btn .basket-icon {
        width: 18px;
        height: 18px;
      }
    }
  </style>
`;

// Inject styles into document head
document.head.insertAdjacentHTML('beforeend', addToCartStyles);

/// {% comment %}  Ending     code created by faisal codex {% endcomment %}